// @ts-nocheck
import { createQuerySuggestionsPlugin } from "@algolia/autocomplete-plugin-query-suggestions";
import {useConfigContext} from "../../ConfigProvider.tsx";

export const useQuerySuggestions = () => {
	const {
		searchClient,
		algoliaConfig: { algoliaIndexName, customizedUrl },
	} = useConfigContext();
	return createQuerySuggestionsPlugin({
		searchClient,
		indexName: algoliaIndexName,
		getSearchParams({ state }) {
			const query = state?.query || "";
			if (!query) {
				return { hitsPerPage: 3 };
			}
			const searchParams = {
				hitsPerPage: 8,
				facetFilters: [
					`hierarchicalCategories.lvl1.name:${query}`,
					`hierarchicalCategories.lvl2.name:${query}`,
					`hierarchicalCategories.lvl3.name:${query}`,
				],
				clickAnalytics: true,
			};
			return searchParams;
		},
		transformSource({ source }) {
			if (!source.getItems) {
				throw new Error("source.getItems is not defined in transformSource");
			}
			return {
				...source,
				sourceId: "categories",
				getItems(params) {
					const query = params.query || "";
					if (!query) {
						return [];
					}
					return searchClient
						.search([
							{
								indexName: algoliaIndexName,
								query,
								params: {
									hitsPerPage: 8,
									filters: "",
									typoTolerance: true,
								},
							},
						])
						.then((response) => {
							const hits = response.results[0].hits;
							const categoriesSet = new Set();
							hits.forEach((hit) => {
								if (hit.hierarchicalCategories) {
									Object.entries(hit.hierarchicalCategories).forEach(([level, category]) => {
										if (category?.name && (level === "lvl1" || level === "lvl2" || level === "lvl3")) {
											categoriesSet.add(
												JSON.stringify({
													level,
													name: category.name,
													slug: category.slug,
													category_icon: category.category_icon,
												})
											);
										}
									});
								}
							});
							const categories = Array.from(categoriesSet)
								.map((item) => JSON.parse(item))
								.slice(0, 10);
							return categories.map((category) => ({
								query: query,
								category: category.name,
								slug: category.slug,
								category_icon: category?.category_icon?.length > 0 ? "/userdata/dcshop/category_icon/" + category.category_icon : null,
								link: `/${customizedUrl}/search/?${algoliaIndexName}input_search=${query}&${algoliaIndexName}[menu][hierarchicalCategories.${category.level}.name]=${encodeURIComponent(
									category.name
								)}`,
							}));
						})
						.catch((error) => {
							console.error("Error in search:", error);
							return [];
						});
				},
				templates: {
					...source.templates,
				},
			};
		},
	});
};
